export const LOGIN_LOADING = "auth/login/loading";
export const LOGIN_SUCCESS = "auth/login/success";
export const LOGIN_ERROR = "auth/login/error";